/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import { toast } from 'react-toastify';
import { createHashicorpUser } from '../../../../../../services/hashicorp/hashicorp';
import HashicorpUserCreationForm from './HashicorpUserCreationForm';
import { useDispatch } from 'react-redux';
import { getAllHashicorpUsers } from '../../../../../../store/reducers/hashicorp/hashicorpAction';

const HashicorpUserCreation = () => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    // Handle open/close dialog
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);



    // Handle form submission
    const handleSubmit = async (values) => {
        try {
            console.log('values',values)
            await createHashicorpUser(values);
            toast.success('User was registred successfully');
            await dispatch(getAllHashicorpUsers({ "authMethod": "userpass" })).unwrap();

            handleClose();

        } catch (error) {
            toast.error(error?.response?.data?.error?.message);

            handleClose();

        }
    };
    return (
        <>
            <Button variant="contained" color="primary" style={{ float: 'right' }} onClick={handleOpen}>Create New User</Button>
            {/* Dialog for Adding User */}
            <DialogContainer
                open={open}
                handleClose={handleClose}
            >
                <Box sx={{ mt: 2 }}>
                    <Formik
                        initialValues={{
                            userName: '',
                            userPass: '',
                            policyName: 'userpass',
                            confirmPassword: ''
                        }}
                        validationSchema={Yup.object().shape({
                            userName: Yup.string().min(2).max(40).required('User Name is required.'),
                            userPass: Yup.string().min(8).max(30).required('Password is required.'),
                            policyName: Yup.string().min(2).max(40).required('Policy Name is required.'),
                            confirmPassword: Yup.string()
                                .min(8)
                                .max(30)
                                .oneOf([Yup.ref('userPass'), null], 'Passwords must match')
                                .required('Password confirmation is required'),
                        })}
                        onSubmit={(
                            values
                        ) => {
                            handleSubmit(values)
                        }
                        }
                    >
                        {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                            <HashicorpUserCreationForm
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                isSubmitting={isSubmitting}
                                handleClose={handleClose}
                                errors={errors}
                                touched={touched} />
                        )}
                    </Formik>
                </Box>

            </DialogContainer>
        </>
    )

}

export default HashicorpUserCreation;
